import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { PageLoader } from './ui/Spinner';

interface Props {
  children: React.ReactNode;
  roles?: string[];
  permission?: string;
}

export function ProtectedRoute({ children, roles, permission }: Props) {
  const { user, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    if (permission && user.role === 'USER' && user.permissions?.[permission] === true) {
      return <>{children}</>;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
